import { ChartSortEnum } from '../../interfaces';
import { IconName } from '../../../Icon';

interface IChartSortingLookupValue {
  icon: IconName;
  hint: string;
}

export const chartSortingLookup: Record<
  ChartSortEnum,
  IChartSortingLookupValue
> = {
  [ChartSortEnum.ASC]: {
    icon: 'sort-ascending-order',
    hint: 'Ascending sorting order',
  },
  [ChartSortEnum.DESC]: {
    icon: 'sort-descending-order',
    hint: 'Descending sorting order',
  },
  [ChartSortEnum.NONE]: {
    icon: 'sort-default-order',
    hint: 'Default sorting order',
  },
};
